export const ALLOWED_NICHES = 5;
export const MAX_NICHES_MESSAGE = "Content can be added to a maximum of 5 niches";
export const NOT_AVAILABLE_MESSAGE = "This content has already been submitted to the moderation queue for your chosen Niche";
export const NOT_MATCHED_TAGS_PREFS_MESSAGE = "This content does not match the tags and preferences of the chosen Niche";
